import React from 'react'
import { object, string, array, bool } from 'prop-types'
import { register, format } from 'timeago.js'
import Case from 'case'
import { FormattedMessage } from 'react-intl'
import { LanguageContextConsumer } from '../../providers/LanguageProvider'
import { urlWithTrack } from '../../helpers/common'
import { sendClickEventToInsights } from '../../utils/insights'
import { ARTICLES, EVENTS, COMPETITIONS, EMPTY_ARRAY, NUMERAL, EMPTY_OBJECT } from '../../utils/constants'
import AdLink from '../ui/ad-link/AdLink'
import SaveButton from '../ui/button/SaveButton'
import Image from '../ui/image/Image'
import Insights from './Insights'
import { articleMessages as messages } from './messages'

// registering languages
register('es', require('timeago.js/lib/lang/es'))
register('pt', require('timeago.js/lib/lang/pt_BR'))
register('zh', require('timeago.js/lib/lang/zh_CN'))

const ARTICLE = 'article'
const EVENT = 'event'
const COMPETITION = 'competition'

const Article = props => {
  let { docType = ARTICLES } = props
  const {
    image,
    insights = EMPTY_OBJECT,
    preview,
    publicationDate = '',
    tags = EMPTY_ARRAY,
    title,
    url = NUMERAL,
    type,
    gridView
  } = props
  const trackedUrl = urlWithTrack(url, type)

  const handleLinkClick = () => {
    sendClickEventToInsights(insights.category, insights.label, insights.value, insights.version)
  }

  switch (docType) {
    case ARTICLES:
      docType = ARTICLE
      break
    case EVENTS:
      docType = EVENT
      break
    case COMPETITIONS:
      docType = COMPETITION
      break
    default:
      docType = ARTICLE
      break
  }
  const featuredImage = image ? image.url_medium : ''

  return (
    <Insights {...insights}>
      <div className='object-container article-object'>
        {/* Image */}
        <div className='object-image article-object__image-container'>
          <AdLink href={trackedUrl} onClick={handleLinkClick}>
            <Image src={featuredImage} alt='article image' />
          </AdLink>
          <SaveButton title={title} image={featuredImage} url={url} gridView={gridView} insights={insights} />
        </div>

        {/* title */}
        <h3 className='object-title article-object__title afd-title-big'>
          <AdLink className='afd-title--black-link' href={trackedUrl} onClick={handleLinkClick}>
            {title}
          </AdLink>
        </h3>

        {/* metadata */}
        <ul className='object-metadata'>
          {!!publicationDate && (
            <li>
              <LanguageContextConsumer>
                {context => Case.sentence(format(publicationDate, context.state.locale))}
              </LanguageContextConsumer>
            </li>
          )}
          <li className={publicationDate ? 'object-metadata__extra' : ''}>
            <FormattedMessage {...messages[docType]} />
          </li>
        </ul>

        {/* content */}
        <div className='object-content article-object-content'>
          {/* preview */}
          {!!preview && <p>{preview}</p>}

          {/* tags */}
          {tags.length > 0 && (
            <p>
              <span className='object-content__bold'>{`Tags: `}</span>
              {tags.slice(0, 4).map((item, index) => (
                <AdLink key={index} href={urlWithTrack(item.url, type)}>
                  {!!index && ', '}
                  {item.name}
                </AdLink>
              ))}
            </p>
          )}
        </div>
      </div>
    </Insights>
  )
}

Article.propTypes = {
  image: object,
  preview: string,
  publicationDate: string,
  tags: array,
  title: string,
  type: string,
  url: string,
  insights: object,
  docType: string,
  gridView: bool
}

export default React.memo(Article)
